/**
 * 상세 패널의 Trade Partner 칸은 `{ id, name, … }` 객체로 온다(그리드도 `.name`을 그린다).
 * 옛 데이터나 테스트처럼 id 숫자만 올 때는 마스터 목록에서 이름을 찾는다.
 */
const party = (value, tradePartners = []) => {
    if (value && typeof value === 'object') return { id: value.id ?? null, name: value.name ?? value.fullname ?? '' };
    return { id: value ?? null, name: tradePartners.find((t) => t.id === value)?.name ?? '' };
};

/**
 * 상세 패널의 HBL 행·컨테이너 행·마스터 행을 PL 화면이 쓰는 한 덩어리로 묶는다.
 * PL 화면은 운송 타입별 컬럼명을 몰라도 되게 여기서만 흡수한다.
 * 항공은 컨테이너 대신 Alias 행에 배분하므로 alias를 컨테이너 번호 자리에 넣고 규격은 비운다. 적재 한도·적재율은 서버가 집계한다.
 */
export function buildPlHbl({ hblRow, containerRows, mainRow, tradePartners, isAir = false }) {
    const client = party(mainRow.il_trade_partner_id_client, tradePartners);
    const shipper = party(hblRow.il_trade_partner_id_shipper, tradePartners);
    const consignee = party(hblRow.il_trade_partner_id_consignee, tradePartners);
    return {
        id: hblRow.id,
        hbl: hblRow.hbl ?? hblRow.hawb ?? '',
        job_no: mainRow.il_opus_reference_id?.name ?? mainRow.il_opus_reference_id ?? '',
        client,
        shipper_id: shipper.id,
        consignee_id: consignee.id,
        shipper_name: shipper.name,
        consignee_name: consignee.name,
        eta: mainRow.eta ?? null,
        unit_label: isAir ? 'Alias' : 'Container(s)',
        containers: isAir
            ? containerRows.filter((c) => c.alias).map((c) => ({ id: c.id, cntr_number: c.alias, volume: '' }))
            : containerRows.filter((c) => c.cntr_number).map((c) => ({ id: c.id, cntr_number: c.cntr_number, volume: c.volume ?? '' })),
    };
}
